import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, httpsCallable } from 'firebase/functions';

// Import emulator connectors only if needed (currently commented out to avoid ESLint warnings)
// import { connectAuthEmulator } from 'firebase/auth';
// import { connectFirestoreEmulator } from 'firebase/firestore';
// import { connectStorageEmulator } from 'firebase/storage';
// import { connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyA_I6EfpAJG6FiTxblGVwLm47NOFfIjGao",
  authDomain: "a-r-t-i-f-a-c-t.firebaseapp.com",
  projectId: "a-r-t-i-f-a-c-t",
  storageBucket: "a-r-t-i-f-a-c-t.appspot.com",
  messagingSenderId: "675973442567",
  appId: "1:675973442567:web:ada0ee4dc4adacf01c8ea2"
};

// Initialize Firebase
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const firestore = getFirestore(app); // Alias for backward compatibility
export const storage = getStorage(app);
export const functions = getFunctions(app);

// CRITICAL: Set persistence IMMEDIATELY and SYNCHRONOUSLY
// This must happen before any auth state listeners
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Failed to set auth persistence:', error);
});

// Connect to emulators in development (uncomment if needed)
if (process.env.NODE_ENV === 'development') {
  // Uncomment these if you want to use emulators in development
  // You'll need to uncomment the imports above as well
  
  // connectAuthEmulator(auth, 'http://localhost:9099');
  // connectFirestoreEmulator(db, 'localhost', 8080);
  // connectStorageEmulator(storage, 'localhost', 9199);
  // connectFunctionsEmulator(functions, 'localhost', 5001);
}

// Configure Firebase Auth settings
auth.useDeviceLanguage();

// Helper functions
export const getCurrentUser = () => {
  return auth.currentUser;
};

export const isUserLoggedIn = () => {
  return !!auth.currentUser;
};

// Cloud Functions helpers - ALL YOUR DEPLOYED FUNCTIONS
export const setAdminClaim = httpsCallable(functions, 'setAdminClaim');
export const createCheckoutSession = httpsCallable(functions, 'createCheckoutSession');
export const analyzeProduct = httpsCallable(functions, 'analyzeProduct');
export const analyzeImage = httpsCallable(functions, 'analyzeImage');
export const fetchDiscoverContent = httpsCallable(functions, 'fetchDiscoverContent');
export const uploadImage = httpsCallable(functions, 'uploadImage');
export const semanticProductSearch = httpsCallable(functions, 'semanticProductSearch');
export const fetchLiveRestaurantData = httpsCallable(functions, 'fetchLiveRestaurantData');
export const populateLocationData = httpsCallable(functions, 'populateLocationData');
export const updatePasswordWithToken = httpsCallable(functions, 'updatePasswordWithToken');

// Export app as default
export default app;